import { useState } from 'react';
import apiService from '../../axios/apiService';
import { message } from 'antd';

export const useMarkInvoiceAsPaid = () => {
  const [loading, setLoading] = useState(false);
  const markInvoiceAsPaid = async (invoiceId) => {
    // Fetch case
    setLoading(true);
    try {
      await apiService.markInvoiceAsPaid(invoiceId);
      message.success('Invoice marked as paid successfully');
    } catch (error) {
      console.log('Error: ', error);
      message.error('Failed to mark invoice as paid');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    markInvoiceAsPaid,
  };
};
